export const DAY_KEYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun", "holiday"] as const;

export const HOUR_KEYS = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
] as const;

export const SCHEDULE_METRICS = ["appliances", "illumination", "ventilation", "occupancy"] as const;

export type DayKey = (typeof DAY_KEYS)[number];

export type ScheduleCellValue = null | number;

export type ScheduleCompletionRates = {
  metrics: Record<ScheduleMetric, number>;
  scenarios: Record<ScheduleScenario, number>;
  sections: Record<ScheduleSection, number>;
};

export type ScheduleDataStore = Record<ScheduleScenario, Record<ScheduleMetric, Record<ScheduleSection, ScheduleGrid>>>;

export type ScheduleDimensionOption = {
  id: string;
  label: string;
};

export type ScheduleDimensions = {
  scenarios: ScheduleDimensionOption[];
  sections: ScheduleDimensionOption[];
};

export type ScheduleGrid = Record<DayKey, ScheduleCellValue[]>;

export type ScheduleMetric = (typeof SCHEDULE_METRICS)[number];

export type ScheduleScenario = string;

export type ScheduleSection = string;

export type ScheduleTargetSelection = {
  metrics: ScheduleMetric[];
  scenarios: ScheduleScenario[];
  sections: ScheduleSection[];
};
